import {
    useMemo,
    type FC,
    useRef
} from "react";
import {
    Animated
} from "react-native";
import type ICheckBoxMarkProps from "./type";
import type {
    CheckBoxDashProps
} from "./type";
import {
    getCheckBoxMarkIcon
} from "./util";
import {
    getAppearStyle,
    usePresence
} from "../../../../helpers/motion";
import {
    Check as CheckIcon,
    Minus as MinusIcon
} from "lucide-react-native";
import AnimatedIcon from "../../../animatedIcon";

const CheckBoxDash: FC<CheckBoxDashProps> = ({
    glyphStrokeWidth,
    customTheme,
    glyphColor,
    isAnimated,
    size
}) => {
    const {
        isReduceMotionEnabled,
        progress
    } = usePresence({
        isInitialAnimated: isAnimated,
        enterIntent: "iconAppear",
        isVisible: true,
        customTheme
    });

    const appearStyle = useMemo(() => getAppearStyle({
        isReduceMotionEnabled,
        progress
    }), [
        isReduceMotionEnabled,
        progress
    ]);

    return <Animated.View
        style={appearStyle}
    >
        <MinusIcon
            strokeWidth={glyphStrokeWidth}
            color={glyphColor}
            size={size}
        />
    </Animated.View>;
};

const CheckBoxMark: FC<ICheckBoxMarkProps> = ({
    isAnimated: isAnimatedProp,
    glyphStrokeWidth,
    checkedState,
    customTheme,
    glyphColor,
    size
}) => {
    const isAnimated = useRef(isAnimatedProp).current;

    if(checkedState === "indeterminate") {
        return <CheckBoxDash
            glyphStrokeWidth={glyphStrokeWidth}
            customTheme={customTheme}
            isAnimated={isAnimated}
            glyphColor={glyphColor}
            size={size}
        />;
    }

    if(!isAnimated) {
        return <CheckIcon
            strokeWidth={glyphStrokeWidth}
            color={glyphColor}
            size={size}
        />;
    }

    return <AnimatedIcon
        icon={getCheckBoxMarkIcon({
            strokeWidth: glyphStrokeWidth
        })}
        customTheme={customTheme}
        customColor={glyphColor}
        animationTrigger="mount"
        animation="draw"
        size={size}
    />;
};
export default CheckBoxMark;
